<template>
    <div class="pd-12 top-border-bottom">
        <a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
            <img  src="@/assets/images/back.webp" alt="back" >
            <h5 class="text-capitalize">Back To Select Account</h5>
        </a>
    </div>
    <div class="exch-deposit-wrapper">
        <div class="mr-row-sec">
            <div class="exch-payment-step-content-wrapper">
                <div class="wallet-list-wrapper">
                    <div class="exch-deposit-amount-sec">
                        <div class="exch-upi-title">
                            <label class="sm-bd-font">{{ $t('add-your', 'Add Your') }}
                                <span class="text-capitalize">{{ type }}</span> {{ $t('account-details', 'Account Details') }}
                            </label>
                            <label class="sm-bd-font amount_inpt_filed">{{ $t('amount', 'Amount') }} :
                                <span class="color-even">{{ amount }}</span>
                            </label>
                        </div>
                        <div class="login-page-abc">
                            <div class="login-page">
                                <div class="login-box">
                                    <div class="login-card">
                                        <div class="mobile-input">
                                            <template v-if="type === 'bank'">
                                                <div class="password-input mt-0">
                                                    <span>{{ $t('bank-name', 'Bank Name') }}</span>
                                                    <div class="dropdown bank-dropdown">
                                                        <button class="bank-dropdown-input" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                        {{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}
                                                        </button>
                                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <div class="wallet-search-input">
                                                                <input type="search" v-model="searchBank" class="form-control" :placeholder="$t('search-banks','Search Banks...')">
                                                            </div>
                                                            <template v-if="filteredBankList">
                                                                <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                                                    <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                                                </li>
                                                            </template>
                                                            <template v-else>
                                                                <li>
                                                                    <a class="dropdown-item">{{$t('no-data-found','No data found')}}</a>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <label class="wrong-color" v-if="v$.accountForm.bankId.$error">
                                                    {{ $t('please-select-bank-name', 'Please Select Bank Name') }}.
                                                </label>

                                                <div class="password-input">
                                                    <span>{{ $t('account-holder-name', 'Account holder’s name') }}</span>
                                                    <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')">
                                                </div>
                                                <template v-if="v$.accountForm.holderName.$error">
                                                    <label class="wrong-color" v-if="v$.accountForm.holderName.required.$invalid">
                                                        {{ $t('account-holder-name-is-required', 'Account holder rame is required') }}.
                                                    </label>
                                                    <span v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('min-characters','Account holder name must be 3-100 characters.') }}
                                                    </span>
                                                    <span v-if="v$.accountForm.holderName.alphaName.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}
                                                    </span>
                                                </template>

                                                <div class="password-input">
                                                    <span>{{ $t('account-number', 'Account number') }} </span>
                                                    <input v-model="accountForm.accountNumber" type="tel" maxlength="20" :placeholder="$t('enter-account-number', 'Enter Account Number*')">
                                                </div>
                                                <template v-if="v$.accountForm.accountNumber.$error">
                                                    <label class="wrong-color" v-if="v$.accountForm.accountNumber.required.$invalid">
                                                        {{ $t('ac-number-is-required', 'Account Number is required') }}.
                                                    </label>
                                                    <span v-if="v$.accountForm.accountNumber.accountNoValidator.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('invalid-account-number','Account number must be valid numeric value between 9 to 18 digits.') }}
                                                    </span>
                                                </template>

                                                <div class="password-input">
                                                    <span>{{ $t('ifsc-code', 'IFSC Code') }}</span>
                                                    <input v-model="accountForm.ifscCode" type="text" class="placeholder-text" :placeholder="$t('enter-ifsc-code', 'Enter IFSC Code*')">
                                                </div>
                                                <template v-if="v$.accountForm.ifscCode.$error">
                                                    <label class="wrong-color" v-if="v$.accountForm.ifscCode.required.$invalid">
                                                        {{ $t('ifsc-code-is-required', 'IFSC code is required') }}.
                                                    </label>
                                                    <span v-if="v$.accountForm.ifscCode.ifscValidator.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('invalid-ifsc','IFSC code should be 11 Alphanumeric Characters.') }}
                                                    </span>
                                                </template>
                                            </template>

                                            <template v-if="type === 'upi' || type === 'wallet'">
                                                <div class="password-input">
                                                    <span>{{ $t('account-holder-name', 'Account holder’s name') }}</span>
                                                    <input type="text" v-model="accountForm.holderName" :placeholder="$t('enter-account-holder-name', 'Enter Account Holder Name*')">
                                                </div>
                                                <template v-if="v$.accountForm.holderName.$error">
                                                    <label class="wrong-color" v-if="v$.accountForm.holderName.required.$invalid">
                                                        {{ $t('account-holder-name-is-required', 'Account holder name is required') }}.
                                                    </label>
                                                    <span v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('min-characters','Account holder name must be 3-100 characters.') }}
                                                    </span>
                                                    <span v-if="v$.accountForm.holderName.alphaName.$invalid" class="wrong-color" for="nameInput">
                                                        {{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}
                                                    </span>
                                                </template>

                                                <template v-if="type === 'upi'">
                                                    <div class="password-input">
                                                        <span>{{ $t('upi-id', 'UPI ID') }}</span>
                                                        <input v-model="accountForm.upiId" type="text" :placeholder="$t('enter-upi-id', 'Enter UPI ID')">
                                                    </div>
                                                    <template v-if="v$.accountForm.upiId.$error">
                                                        <span class="wrong-color" v-if="accountForm.upiId && v$.accountForm.upiId.minLength?.$invalid || v$.accountForm.upiId.maxLength?.$invalid">{{ $t('upi-length','UPI ID must be 5 to 50 characters.') }}</span>
                                                        <span class="wrong-color" v-if="accountForm.upiId && v$.accountForm.upiId.upiValidator?.$invalid">{{ $t('upi-format','Must be in the format of name@bank.') }}</span>
                                                    </template>
                                                </template>
                                                
                                                <template v-if="type === 'wallet'">
                                                    <div class="password-input">
                                                        <span>{{ $t('wallet-id', 'Wallet ID') }}</span>
                                                        <input v-model="accountForm.walletId" type="text" maxlength="20" :placeholder="$t('enter-wallet-id', 'Enter wallet ID* ')">
                                                    </div>
                                                    <template v-if="v$.accountForm.walletId.$error">
                                                        <label class="wrong-color" v-if="v$.accountForm.walletId.required.$invalid">
                                                            {{ $t('wallet-id-is-required', 'Wallet ID is required') }}.
                                                        </label>
                                                        <span class="wrong-color" v-if="v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid">{{ $t('upi-length','Wallet ID must be 8 to 20 characters.') }}</span>
                                                        <span class="wrong-color" v-if="v$.accountForm.walletId.walletValidator.$invalid">{{ $t('wallet-format','Must contain only letters, numbers, @, hyphens, or underscores.') }}</span>
                                                    </template>
                                                </template>

                                                <div class="password-input" v-if="!previewImageUtr">
                                                    <span>{{ $t('qr-code-upload-screenshot', 'QR Code (Upload Screenshot)') }}
                                                        <span class="info-sec-icon">
                                                            <img src="@/assets/images/info.svg" alt="">
                                                            <div class="info-list upi_info_sec">
                                                                <ul>
                                                                    <li>1. {{ $t('upload-a-screenshot-of-a-valid-qr-code-to-proceed', 'Upload a screenshot of a valid QR code to proceed') }}.</li>
                                                                    <li>2. {{ $t('if-qr-code-is-not-detected-exchange-will-not-be-responsible-for-the-losses', 'If QR code is not detected, Exchange will not be responsible for the losses') }}.</li>
                                                                </ul>
                                                            </div>
                                                        </span>
                                                    </span>
                                                    <div class="exch-upload-transaction-img-section">
                                                        <div class="upload-img">
                                                            <img src="@/assets/images/upload-img.webp" alt="upload-img">
                                                        </div>
                                                        <p>{{ $t('upload-transaction-image', 'Upload Transaction Image') }} </p>
                                                        <div class="file-upload-sec show">
                                                            <label for="file" class="file-upload show"> {{ $t('file-upload', 'File Upload') }} </label>
                                                            <input class="form-control profit-input d-none" type="file" id="file" @change="fileUpdateFunc" accept=".png, .webp, .jpg, .jpeg" >
                                                        </div>
                                                        <div v-if="accountForm.file" id="fileList">
                                                            <ul>
                                                                <li>
                                                                    {{ accountForm.file.name }}
                                                                    <span class="list-cross" @click="accountForm.file = null">
                                                                        <img src="@/assets/images/cross-icon.webp" alt="cross-icon" loading="lazy">
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <!-- <label class="wrong-color" v-if="v$.accountForm.file.$error">
                                                        {{ $t('please-upload-qr-code', 'Please Upload QR Code') }} ({{ $t('file-is-required', 'File is required') }}).
                                                    </label> -->
                                                </div>
                                                <div class="number-header col-12 thm-heading d-inline-block upload_qr_code_wrapper" v-if="previewImageUtr">
                                                    <h5 class="mb-2 info-sec team-list-wet">{{ $t('qr-code', 'QR Code') }}</h5>
                                                    <div class="fileList">
                                                        <img class="fileList-img" :src="previewImageUtr" alt="file-list"/>
                                                        <button
                                                            class="add-utr-again" @click="clearPaymentSlip()">
                                                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon" loading="lazy">
                                                        </button>
                                                    </div>
                                                </div>

                                            </template>
                                        </div>
                                        <div class="password-input changed_pass_wrapper">
                                            <span>{{ $t('withdrawal-password', 'Withdrawal Password') }}</span>
                                            <div class="password-input w-100">
                                                <div class="changepassword-box">
                                                    <input  class="pass_log_id"  :type="passwordFieldType"  v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password.replace(/\s/g, ''), 20)"  
                                                    :placeholder="$t('enter-withdrawal-password', 'Enter Withdrawal Password*')">
                                                    <span @click="togglePasswordVisibility('passwordField')" class="fa fa-fw field_icon toggle-password">
                                                        <i class="fas" :class="(passwordFieldType=='text')?'fa-eye':'fa-eye-slash'"></i>
                                                    </span>
                                                </div>
                                                <label class="wrong-color" v-if="v$.accountForm.withdrawal_password.$error">
                                                    {{ $t('please-enter-withdraw-password', 'Please Enter Withdraw Password') }}
                                                </label>
                                            </div>
                                            <div class="forgot-check-box-section">
                                                <div class="forgot" v-if="$siteSettings?.data?.business_type == 2"> 
                                                    <a href="javascript:void(0)" class="blue-link" @click="forgetWithdrawModal()">{{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?</a>
                                                </div>
                                            </div>
                                        </div>
                                        <a @click="addAccountServiceCall()" class="green-theme-btn mt- w-100">
                                            {{ $t('save', 'Save') }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <WithdrawalPasswordSetReset ref="withdrawSetReset" :isWithdrawalPasswordSet="isWithdrawalPasswordSet" :is_withdrawal_password_set="is_withdrawal_password_set"  @withdrawalPasswordHasBeenSet="is_withdrawal_password_set = true"/>

    <div class="modal fade modal-footer-sticky worli-Bets-Modal " id="cancelbetModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header withdraw_password_header">
                    <h5 class="text-light">Withdraw password</h5>
                </div>
                <div class="modal-body">
                    <div class="account-delete-msg">
                        <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                    </div>
                    <div class="footer-buttonWrap">
                        <button type="button" class="buttonWrap-btn buttonCancel" data-bs-dismiss="modal" @click="addAccountServiceCall(true)" >{{$t('skip', 'Skip')}}</button>
                        <button class="buttonWrap-btn buttonTheme" data-bs-dismiss="modal" @click="forgetWithdrawModal()">{{$t('continue', 'Continue')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { defineAsyncComponent } from 'vue';
import { openWithdrawPasswordModal } from '../services/withdrawAccountDetails';
import { addAccount } from '../services/withdrawAccountDetails';
import { getUserAccounts } from '../services/withdrawDetails';
import { withdrawWalletAmount, removeAccount  } from '../services/withdrawDetails';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true;
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
const upiValidator = helpers.withMessage(
  "Must be in the format of 'name@bank.'",
  (value) => {
    if (!value) return true
    return /^[A-Za-z0-9]+@[A-Za-z0-9]+$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)

export default {
    name: "WithdrawSelectAccount",
    components:{
        WithdrawalPasswordSetReset
    },
    setup() {
		return { v$: useVuelidate() }
	},
    computed: {
        ...mapGetters([
            'selectedAccountData',
        ]),
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList.filter(item => item.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        }
    },
    inject:['walletConfig'],
    data() {
        return {
            type: '',
            amount: null,
            loading: false,
            bankDetailsList: [],
            accountForm: {
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				phoneNumber: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null
			},
            passwordFieldType: 'password',
            is_withdrawal_password_set:false,
            searchBank:null,
            selectedBank:null,
            previewImageUtr: null,
            selectedBank:null,
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                holderName: { 
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                accountNumber: this.type === 'bank' ? { 
                    required,
                    accountNoValidator
                } : {},
                ifscCode: this.type === 'bank' ? { 
                    required,
                    ifscValidator
                } : {},
                upiId: this.type === 'upi' ? { 
                    minLength: minLength(5),
                    maxLength: maxLength(50),
                    upiValidator
                } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                    walletValidator    
                } : {},
                withdrawal_password: { required },
            }
        };
    },
    mounted() {
        // this.fetchBankDetails();
        // this.isWithdrawalPasswordSet()
        this.bankDetailsList = this.walletConfig?.bank_list
        const item = this.selectedAccountData;
        this.accountForm.paymentMethodId = item.id;
        this.accountForm.paymentTypeName = item.name;
        this.amount = this.$store.getters.withdrawalAmount;
        this.type = item.method_type;
    },
    methods: {
        selectBank(item){
            this.accountForm.bankId = item.id
            this.selectedBank = item.bank_name
            this.searchBank = ''
        },
        clearPaymentSlip() {
            this.previewImageUtr = null;
            this.accountForm.file = undefined;
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        fileUpdateFunc(event) {
            this.accountForm.file = event.target.files[0];

            if (!this.accountForm.file.type.startsWith('image/')) {
                event.target.value = "";
                this.accountForm.file = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            const maxSize = 5 * 1024 * 1024;
            if (this.accountForm.file.size > maxSize) {
                event.target.value = "";
                this.accountForm.file = null;
                this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                return;
            }
            this.previewImageUtr = URL.createObjectURL(this.accountForm.file);
        },
        fetchBankDetails() {
            this.loading = true;
            this.$apiCall('get', 'BANK_DETAILS', null, 'walletConfig')
                .then(response => {
                    this.loading = false;
                    if (response?.status === 200) {
                        const data = response.data;
                        if (data.status === 0) {
                            this.$errorToast(data.debug[0]);
                        } else {
                            this.bankDetailsList = data.data;
                        }
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.$errorToast(error[0]);
                });
        },
        async addAccountServiceCall(){
            this.v$.$touch();
			if (this.v$.$error) {
				// this.$errorToast('Please fill the required fields');
				return;
			}
            let bankDetails = {
                    method_id: this.accountForm.bankId,
                    account_holder_name: this.accountForm.holderName,
                    account_no: this.accountForm.accountNumber,
                    ifsc_code: this.accountForm.ifscCode,
                    withdrawal_password: this.accountForm.withdrawal_password,
                };

                let upiDetails = {
                    method_id: this.selectedAccountData.id,
                    account_holder_name: this.accountForm.holderName,
                    upi_id: this.accountForm.upiId,
                    qr_code: this.accountForm.file,
                    crypto_wallet_id: this.accountForm.walletId,
                    withdrawal_password: this.accountForm.withdrawal_password,
                };
            if(this.type === 'upi' && upiDetails.upi_id == '' && upiDetails.qr_code == null){
                this.$errorToast('At least one field is required UPI ID or QR code.')
                return false;
            }
            let response = await addAccount(this.selectedAccountData, this.type, bankDetails, upiDetails)
            if(response){
                this.clearError();
                this.$router.back();
            }
        },
         clearError() {
            this.accountForm = {
                bankId: null,
                holderName: null,
                accountNumber: null,
                ifscCode: null,
                withdrawal_password: null,
            },
            this.upiDetails = {
                holderName: null,
                upiId: null,
                file: null,
                withdrawal_password: null,
            },
            this.selectedBank = null;
            this.v$.$reset();
        },
        forgetWithdrawModal(){
            this.openWithdrawPasswordModal();
        },
        async openWithdrawPasswordModal(){
            try{
                let response = await openWithdrawPasswordModal()
                if(!response?.error){
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    // this.addAccount();
                    this.$errorToast(response?.error);
                }
                this.$helper.closeModal('withdrawalPasswordWarning');
            }
            catch(error){
                console.log(error)
            }
        },
    }
}
</script>